import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

class Form extends Component {
    constructor(props) {
        super(props);

        this.state = {
            keywords: this.props.keywords
        }

        this.getKeywords = this.getKeywords.bind(this);
        this.doAction = this.doAction.bind(this);
    }

    getKeywords(e) {
        this.setState({
            keywords: e.target.value
        });
    }

    doAction(e) {
        e.preventDefault();
        let pushKeywords = this.keywordInput.value.trim().replace(/(\s)+/g, '$1');
        this.props.push(pushKeywords, '2', '0');
    }

    // URLが変更された場合(テキストボックス内のvalue切り替えのためにURL変更を検知する)
    componentWillReceiveProps = nextProps => {
        if (nextProps.location !== this.props.location) {
            const params = new URLSearchParams(nextProps.location.search);
            const keywords = (params.get('Keywords') ? params.get('Keywords') : '');
            
            this.setState({
                keywords: keywords
            });
        }
    };

    render() {
        return (
            <form className="SearchBox" onSubmit={this.doAction}>
                <div className="SearchFormInner">
                    <div className="SearchBox cFix">
                        <div className="SearchTextBox">
                        <input type="text" className="SearchText ui-autocomplete-input" ref={input => {this.keywordInput = input;}} id="Focus" maxLength="2048" title="キーワードを入力してください" value={this.state.keywords} onChange={this.getKeywords} />
                        </div>
                        <div className="SearchSubmitBox">
                        <input type="submit" className="SearchSubmit" value="検索" />
                        </div>
                    </div>
                    <div className="search_help">
                    <ul><li><a href="https://support.asahi.com/hc/ja/articles/28293967984663?iref=s_search">検索の使い方</a></li>
                        <li className="Guest MemberSimple"><a href="http://digital.asahi.com/info/about/find.html?iref=s_search#keyword">検索条件を保存するには？（マイキーワードへ）</a></li>
                        <li className="MemberDigiW"><a href="http://digital.asahi.com/member_mykeyword/?iref=s_search">検索条件を保存するには？（マイキーワードへ）</a></li>
                    </ul>
                    </div>
                </div>
            </form>
        );
    }
}
Form.propTypes = {
    keywords: PropTypes.string.isRequired,
    sort: PropTypes.string.isRequired,
    push: PropTypes.func.isRequired,
}
export default withRouter(Form);